module.exports = __webpack_public_path__ + "img/zfr1.c688c811.jpg";